import { createSlice, createAction } from '@reduxjs/toolkit';
import { IState } from 'shared/interfaces/state.interface';
import { IUser } from 'shared/interfaces/user.interface';
import { initialStore } from '../initial-store';
import { UserStatus } from 'shared/enums';

// Actions
export const getAffAdmins = createAction(
  'affiliateAdmins/GET_AFFILIATE_ADMINS',
  (payload = {}) => ({
    payload
  })
);
export const createAffiliateAdmin = createAction(
  'affiliateAdmins/CREATE_AFFILIATE_ADMIN',
  (payload) => ({
    payload
  })
);
export const deleteAffiliateAdmin = createAction(
  'affiliateAdmins/DELETE_AFFILIATE_ADMIN',
  (payload) => ({ payload })
);
export const updateAffiliateAdmin = createAction(
  'affiliateAdmins/UPDATE_AFFILIATE_ADMIN',
  (payload) => ({
    payload
  })
);

const affiliateAdminsSlice = createSlice({
  name: 'affiliateAdmins',
  initialState: initialStore.affiliateAdmins,
  reducers: {
    getAffiliateAdmins: (state, { payload }) => {
      (state.affiliateAdmins as IUser[]) = [...payload].sort(
        (a: IUser, b: IUser) => {
          if (a.status !== b.status) {
            return a.status === UserStatus.Active ? -1 : 1;
          }
          return b.updatedAt.localeCompare(a.updatedAt);
        }
      );
      state.isLoading = false;
    },
    createAffiliateAdminSuccess: (state, { payload }) => {
      (state.affiliateAdmins as IUser[]) = [
        payload.user,
        ...state.affiliateAdmins
      ];
    },
    removeAffiliateAdmin: (state, { payload }) => {
      state.affiliateAdmins = state.affiliateAdmins.filter(
        ({ id }) => id !== payload
      );
    },
    updateAffiliateAdminFail: (state) => {
      state.isLoading = false;
    },
    updateAffiliateAdminSuccess: (state, { payload }) => {
      const userIndex = state.affiliateAdmins.findIndex(
        ({ id }) => id === payload.id
      );
      (state.affiliateAdmins as IUser[]).splice(userIndex, 1, payload);
      state.isLoading = false;
    }
  }
});
export const {
  getAffiliateAdmins,
  createAffiliateAdminSuccess,
  removeAffiliateAdmin,
  updateAffiliateAdminSuccess,
  updateAffiliateAdminFail
} = affiliateAdminsSlice.actions;

export const { reducer } = affiliateAdminsSlice;

// Selectors
export const getAffiliateAdminsLoadingSelector = (state: IState) =>
  state && state.affiliateAdmins.isLoading;

export const getAffiliateAdminsSelector = (state: IState) =>
  state && state.affiliateAdmins;
